import { render, staticRenderFns } from "./AssetCommands.vue?vue&type=template&id=b37fa8ee&"
import script from "./AssetCommands.vue?vue&type=script&lang=js&"
export * from "./AssetCommands.vue?vue&type=script&lang=js&"
import style0 from "./AssetCommands.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports